// extracted by mini-css-extract-plugin
export default {"container":"recFoodOnMain_container__71lZv","title":"recFoodOnMain_title__av5-E","link":"recFoodOnMain_link__XKq2N"};